import { render, staticRenderFns } from "./AssetsCheck.vue?vue&type=template&id=74848c4a&scoped=true"
import script from "./AssetsCheck.vue?vue&type=script&lang=js"
export * from "./AssetsCheck.vue?vue&type=script&lang=js"
import style0 from "./AssetsCheck.vue?vue&type=style&index=0&id=74848c4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74848c4a",
  null
  
)

export default component.exports